import { AppInitService } from './_services/app-init.service';

export function initApp(
    appInit: AppInitService
) {
    return (): Promise<any> => {
        return appInit.init();
    }
}
